import React from 'react'

export default function CheckIcon({ className = 'text-white', size = 12 }) {
  return (
    <svg
      className={className}
      width={size}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2928_17296)">
        <path
          d="M11.7212 1.96136C11.3499 1.58959 10.747 1.58982 10.3752 1.96136L4.31744 8.01936L1.62503 5.32697C1.25325 4.95519 0.650609 4.95519 0.278832 5.32697C-0.0929441 5.69874 -0.0929441 6.30139 0.278832 6.67316L3.6442 10.0385C3.82998 10.2243 4.07357 10.3174 4.31719 10.3174C4.5608 10.3174 4.80463 10.2245 4.9904 10.0385L11.7212 3.30753C12.0929 2.93602 12.0929 2.33311 11.7212 1.96136Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_2928_17296">
          <rect width="12" height="12" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  )
}
